import React from "react"

import { GreenWaveDisplayGraph as GreenWaveDisplayGraphComponent, Header } from "components"

export const GreenWaveDisplayGraph: React.FC = () => {
 return (
  <React.Fragment>
   <Header />
   <GreenWaveDisplayGraphComponent />
  </React.Fragment>
 )
}
